import type { HeroProps } from '@/components/PolicyTwo/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/transparency/transparency_report_og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/PolicyTwo/policyTwo__de-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout, showAskUsAnything: true },
  seo: {
    ...sharedConfig['de-DE'].seo,
    title: 'Die Versicherungspolice 2.0 | Lemonade',
    description:
      'Wir präsentieren die Versicherungspolice 2.0 von Lemonade: Eine radikal vereinfachte, modernisierte und digitalisierte Police. Im Einklang mit unserem Mantra, die Versicherung von einem notwendigen Übel in ein soziales Gut umzuwandeln, freuen wir uns, wenn jeder dazu beiträgt und von der weltweit ersten Open-Source-Versicherungspolice profitieren kann.',
    ogImage: og.src,
  },
  hero: {
    title: 'Die weltweit erste\nOpen Source Versicherungspolice',
    subtitle:
      'Policy 2.0 is a radically simplified, modernized, and digitized insurance policy. This means you can actually read and understand it!',
    ctaLabel: 'read the policy',
  },
  MDXContent: content as DocumentTypes,
};
